import React, { useState } from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { GrCertificate } from "react-icons/gr";
import ModalHeader from '../../components/ModalHeader';
import Certificate from '../../components/Certificate';

const TranningModal = ({data, item}) => {
    const [show, setShow] = useState(false);
   
    return (
        <>   
            {item?.Training?.trainingStatus === "COMPLETED" ? (
            <button className="dropbtn p-1" onClick={() => setShow(true)}>
             <GrCertificate size={20} /> Certificate
            </button>
             ) : null}

            <Modal fullscreen show={show} onHide={() => setShow(false)}>
                <ModalHeader setShow={setShow} headerTitle={"Certificate"} />
                <Modal.Body>
                    <div id='ViewJob__Container'>
                        <main>
                            <Certificate data={data} item={item}/>
                        </main>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default TranningModal;
